/**
 *
 */
import { environment } from "./../../../../../../src/environments/environment";

class EmailAnimations {
    component_id;
    quillEditor: any;

    modules = {
        syntax: true,
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'color': [] }, { 'background': [] }, { 'align': [] }],
            [{ 'font': [] }],
            ['link', 'image'],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['clean']
          ],
          handlers: {
            image: () => this.imageHandler()
          }
        },
        clipboard: {
          matchVisual: false
        }
      };

    is_editor_enabled = false;

    show_recipient_list = {
        cc: {
            input: false,
            mouse_over: false
        },
        bcc: {
            input: false,
            mouse_over: false
        }
    }

    cc_input_element: any;
    cc_input_list: any;


    bcc_input_element: any;
    bcc_input_list: any;

    constructor(component_id) {
        this.component_id = component_id;
    }

    loadFormElements() {

        // window.addEventListener('load', () => {
        /** */
            // window.addEventListener('click', () => {
            //     if (!this.show_recipient_list.cc.mouse_over) {
            //         this.show_recipient_list.cc.input = false;
            //     }

            //     if (!this.show_recipient_list.bcc.mouse_over) {
            //         this.show_recipient_list.bcc.input = false;
            //     }
            // });

        /** CC */
        this.cc_input_element = document.getElementById(`input-cc-${this.component_id}`);
        this.cc_input_list = document.getElementById(`input-cc-list-${this.component_id}`);
        if (!this.cc_input_element || !this.cc_input_list) return;

            this.cc_input_element.addEventListener('focus', () => {
                this.show_recipient_list.cc.input = true;
                this.show_recipient_list.bcc.input = false;
            });

            this.cc_input_element.addEventListener('blur', () => {
                if (!this.show_recipient_list.cc.mouse_over) {
                    this.show_recipient_list.cc.input = false;
                }
            });

            this.cc_input_element.addEventListener('click', e => {
                e.stopPropagation();
                this.show_recipient_list.bcc.input = false;
            });

            this.cc_input_list.addEventListener('mouseout', () => {
                this.show_recipient_list.cc.mouse_over = false;
            });

            this.cc_input_list.addEventListener('mouseover', () => {
                this.show_recipient_list.cc.mouse_over = true;
            });

            this.cc_input_list.addEventListener('click', e => {
                e.stopPropagation();
                this.show_recipient_list.cc.input = true;
            });

            /**
             * BCC
             */
            this.bcc_input_element = document.getElementById(`input-bcc-${this.component_id}`);
            this.bcc_input_list = document.getElementById(`input-bcc-list-${this.component_id}`);

            this.bcc_input_element.addEventListener('focus', () => {
                this.show_recipient_list.bcc.input = true;
                this.show_recipient_list.cc.input = false;
            });

            this.bcc_input_element.addEventListener('blur', () => {
                if (!this.show_recipient_list.bcc.mouse_over) {
                    this.show_recipient_list.bcc.input = false;
                }
            });

            this.bcc_input_element.addEventListener('click', e => {
                e.stopPropagation();
                this.show_recipient_list.cc.input = false;
            });

            this.bcc_input_list.addEventListener('mouseout', () => {
                this.show_recipient_list.bcc.mouse_over = false;
            });

            this.bcc_input_list.addEventListener('mouseover', () => {
                this.show_recipient_list.bcc.mouse_over = true;
            });

            this.bcc_input_list.addEventListener('click', e => {
                e.stopPropagation();
                this.show_recipient_list.bcc.input = true;
            });

            const quill_toolbars: NodeList = document.querySelectorAll(`#email-area-${this.component_id} .ql-toolbar`);
            const quill_editors: NodeList = document.querySelectorAll(`#email-area-${this.component_id} .ql-editor`);

            quill_editors.forEach((quill_editor: HTMLElement) => {
                quill_editor.style.height = '300px';
                quill_editor.setAttribute('tabindex', '5');
            })

            quill_toolbars.forEach((quill_toolbar: HTMLElement) => {
                quill_toolbar.style.position = 'sticky';
                quill_toolbar.style.top = '0';
                quill_toolbar.style.zIndex = '900';
                quill_toolbar.style.backgroundColor = "#fff";
            })

        this.is_editor_enabled = true;
        // });
    }

    setEditorInstance(editor: any) {
        this.quillEditor = editor;
    }

    imageHandler() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append('image', file);

            try {
                const res = await fetch(`${environment.chatServiceUrl}/email-signature/signature-image`, {
                    method: 'POST',
                    body: formData
                });
                const { url } = await res.json();

                const range = this.quillEditor.getSelection(true);
                this.quillEditor.insertEmbed(range.index, 'image', url, 'user');
                this.quillEditor.setSelection(range.index + 1);
                this.quillEditor.update('user');
            } catch (err) {
                console.error('Image upload failed:', err);
            }
        };
    }

    show_list(type: string) {
        const { input } = this.show_recipient_list[type];
        return input;
    }

    hide_list(event, type: string) {
        event.stopPropagation();
        this.show_recipient_list[type].input = false;
    }

    determine_placeholder(type: string, emailHelper: any) {
        const recipient_class = type == 'cc' ? 'selectedCcRecipients' : 'selectedBccRecipients';
        const recipient_list = emailHelper.convertObjectToArray(emailHelper[recipient_class]);
        let recipient_string = '';
        if (recipient_list.length > 0 && type =='cc') {
            recipient_string = recipient_list.length > 1 ? `${recipient_list[0].email} + ${recipient_list.length - 1} Cc` : `${recipient_list[0].email}`;
        }
        if (recipient_list.length > 0 && type =='bcc') {
            recipient_string = recipient_list.length > 1 ? `${recipient_list[0].email} + ${recipient_list.length - 1} Bcc` : `${recipient_list[0].email}`;
        }
        return this.show_recipient_list[type].input ? '' : recipient_string;
    }
}

export default EmailAnimations;
